export class ClientTeamDeactivationReasonModel {
    constructor() {
        this.teamId = "";
        this.deactivatedReason = "";
        this.deactivationDateAsString = "";
    }
}
export default class ClientTeamDeactivationReason extends ClientTeamDeactivationReasonModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
